import axios from './_nestAxios'

export const obtenerAprobadasAsDetallesPendientesxIdSocio = idSocio =>
  axios.get('/requerimientos/f_aprob/detalles/f_pend', { params: { tipoConsulta: 'x-socio', idSocio } })

export const obtenerDetallesxIdsEmpaquetadosAsOrdenCompraInfo = ids =>
  axios.get('/requerimientos/empaquetados', {
    params: { ids, tipoConsulta: 'orden-compra-info' }
  })

export const obtenerEmpaquetadosAbiertosxIdSocio = idSocio =>
  axios.get('/requerimientos/empaquetados', { params: { tipoConsulta: 'x-socio', idSocio } })

export const obtenerAprobadasAsDetallesPendientesxSinAsignar = () =>
  axios.get('/requerimientos/empaquetados', { params: { tipoConsulta: 'sin-asignar' } })

export const obtenerEmpaquetadosTodosParaOrdenCompra = () =>
  axios.get('/requerimientos/empaquetados', { params: { tipoConsulta: 'todos-para-oc' } })

export const obtenerAprobadasAsDetallesPendientes = (params = {}) =>
  axios.get('/requerimientos/f_aprob/detalles/f_pend', { params })

export const obtenerxIdAsEdicion = id => axios.get(`/requerimientos/${id}`)

export const descargarPdfA4xId = id => axios.get(`/requerimientos/${id}/descargar/pdf/a4`, { responseType: 'blob' })

export const nuevo = data => axios.post('/requerimientos', data)

export const actualizarxIdAsCambioEstado = (id, data) => axios.put(`/requerimientos/${id}/estado`, data)

export const actualizarxIdsDetallesAsEvaluacion = data => axios.put('/requerimientos/detalles', data)

export const actualizarxId = (id, data) => axios.put(`/requerimientos/${id}`, data)

export const eliminarxId = id => axios.delete(`/requerimientos/${id}`)

export const obtenerOficinasDelUsuario = () => {
  return axios.get('/requerimientos/oficinas/usuario')
}

// Flujo v2 - Trazabilidad
export const actualizarxIdAsCambioEstadoConTrazabilidad = (id, data) =>
  axios.put(`/requerimientos/${id}/estado-trazabilidad`, data)

export const obtenerTrazabilidadxId = id => axios.get(`/requerimientos/${id}/trazabilidad`)

// Cotizaciones
export const obtenerCotizacionesxId = id => axios.get(`/requerimientos/${id}/cotizaciones`)

export const agregarCotizacion = (id, file, comentarioLogistica) => {
  const formData = new FormData()
  formData.append('file', file)
  if (comentarioLogistica) formData.append('comentarioLogistica', comentarioLogistica)
  return axios.post(`/requerimientos/${id}/cotizaciones`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const descargarCotizacion = idCotizacion =>
  axios.get(`/requerimientos/cotizaciones/${idCotizacion}/descargar`, { responseType: 'blob' })

export const eliminarCotizacion = idCotizacion => axios.delete(`/requerimientos/cotizaciones/${idCotizacion}`)

export const seleccionarCotizacion = (idRequerimiento, idCotizacion) =>
  axios.put(`/requerimientos/${idRequerimiento}/cotizaciones/${idCotizacion}/seleccionar`)

export const descargarReporteConsolidado = params =>
  axios.get('/requerimientos/descargar/reporte-consolidado', { responseType: 'blob', params })

export const actualizarxIdAsCambioEstadoConTrazabilidadFormData = (id, formData) =>
  axios.put(`/requerimientos/${id}/estado-trazabilidad`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })

export const descargarAdjuntoTrazabilidad = idTrazabilidad =>
  axios.get(`/requerimientos/trazabilidad/${idTrazabilidad}/adjunto`, { responseType: 'blob' })

export const obtenerDetallesEvaluacion = id => axios.get(`/requerimientos/${id}/detalles-evaluacion`)

export const obtenerGestionEntregasAlmacen = (params = {}) =>
  axios.get('/requerimientos/almacen/gestion-entregas', { params })

export const descargarExcelEntregasAlmacen = (params = {}) =>
  axios.get('/requerimientos/almacen/gestion-entregas/excel', { responseType: 'blob', params })

export const descargarPdfEntregasAlmacen = (params = {}) =>
  axios.get('/requerimientos/almacen/gestion-entregas/pdf', { responseType: 'blob', params })

export const obtenerEnAlmacenParaSalida = () =>
  axios.get('/requerimientos/en-almacen/para-salida')

export const obtenerDetallesParaSalida = ids =>
  axios.get('/requerimientos/en-almacen/detalles-para-salida', { params: { ids } })
